export default __webpack_public_path__ + "static/media/careForBaby.1612f687.png";